import {useEffect, useState} from "react";
import adminQuizService from "../../services/AdminQuizService";
import {useParams} from "react-router-dom";
import styles from "./QuizSubmissionsViewer.module.scss";
import BackButton from "../../components/ui/BackButton";

export default function QuizSubmissionsViewer(){
	const [table,setTable] = useState(null);
	const {quizId} = useParams();

	useEffect(()=>{
		if (!table){
			getSubmissionsTable();
		}
	}, []);

	const getSubmissionsTable = async () => {
		let data = await adminQuizService.getSubmissionTable(quizId);
		setTable(data);
	}

	function SubmissionTable({ headers, rows }){
		return (
			<div className={styles.tableContainer}>
				<table className={styles.table}>
					<thead>
					<tr>
						{headers.map((header, index) => (
							<th key={index} className={styles.headerCell}>
								{header || 'Untitled Question'}
							</th>
						))}
					</tr>
					</thead>
					<tbody>
					{rows.map((row, rowIndex) => (
						<tr key={rowIndex} className={styles.row}>
							{headers.map((header, colIndex) => (
								<td key={colIndex} className={styles.cell}>
									{row[header] || '-'}
								</td>
							))}
						</tr>
					))}
					</tbody>
				</table>
			</div>
		);
	}

	if (table)
		return <>
			<BackButton/>
			<SubmissionTable headers={table.headers} rows={table.rows} />
	</>;
}